/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icons/view.blocks to change it.
import PreferredIcon from './PreferredIcon/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Icons({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Email/Emails/Content/Email/Icons"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Icons.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreferredIcon
  viewPath={`${viewPath}/PreferredIcon`}
/>
</div>
{children}
</React.Fragment>)
}